import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import {
	MAT_SNACK_BAR_DATA,
	MatSnackBarRef,
} from '@angular/material/snack-bar';
import { from, Observable } from 'rxjs';
import { MatButton } from '@angular/material/button';
import { NgIf } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
	selector: 'app-save-alert',
	template: `
		<div class="save-alert-container">
			<span class="message">{{ data.message }}</span>
			<div class="actions">
				<button mat-flat-button (click)="cancel()" [disabled]="isLoading">
					No
				</button>
				<button
					mat-raised-button
					color="primary"
					(click)="save()"
					[disabled]="isLoading"
				>
					<span *ngIf="!isLoading">Yes</span>
					<mat-spinner
						*ngIf="isLoading"
						diameter="20"
						color="accent"
					></mat-spinner>
				</button>
			</div>
		</div>
	`,
	changeDetection: ChangeDetectionStrategy.Eager,
	styles: [
		`
			.save-alert-container {
				display: flex;
				align-items: center;
				justify-content: space-between;
				gap: 20px;
			}
			.message {
				font-weight: 500;
			}
			.actions {
				display: flex;
				gap: 8px;
			}
			button[mat-raised-button] {
				min-width: 80px;
				display: flex;
				justify-content: center;
				align-items: center;
			}
		`,
	],
	imports: [MatButton, NgIf, MatProgressSpinner],
})
export class SaveAlertComponent {
	isLoading = false;
	constructor(
		@Inject(MAT_SNACK_BAR_DATA)
		public data: { message: string; action: () => Observable<any> },
		private snackBarRef: MatSnackBarRef<SaveAlertComponent>
	) {}

	save() {
		this.isLoading = true;
		from(this.data.action()).subscribe({
			next: () => this.snackBarRef.dismiss(),
			error: () => (this.isLoading = false),
		});
	}
	cancel() {
		if (!this.isLoading) this.snackBarRef.dismiss();
	}
}
